import { Box, Typography } from "@mui/material";
import React from "react";
import {
  blueColor04,
  greyColor37,
  greyColor40,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { INVENTORY_BULK_UPLOAD_STEPPER } from "../../../utils/data";

const UploadStepper = ({ currentPage, handleStepperClick }) => {
  const getCurrentStep = (page) => {
    switch (page) {
      case "download":
        return 0;
      case "upload":
        return 1;
      case "review":
        return 2;
      case "published":
        return 3;

      default:
        return 0;
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={3} ml={8}>
      {INVENTORY_BULK_UPLOAD_STEPPER.map((item, index) => (
        <Box
          sx={{
            width: "210px",
            display: "flex",
            alignItems: "center",
            gap: 2,
            position: "relative",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={1}
            sx={{ cursor: "pointer" }}
            onClick={() => handleStepperClick(item, index)}
          >
            <Box sx={styles.countCircle(getCurrentStep(currentPage) >= index)}>
              {item.id}
            </Box>

            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography
                fontSize={12.5}
                fontWeight={getCurrentStep(currentPage) >= index ? 600 : 500}
                color={
                  getCurrentStep(currentPage) >= index
                    ? blueColor04
                    : greyColor40
                }
              >
                {item.label}
              </Typography>

              {/* <Typography
                fontSize={12}
                fontWeight={400}
                color={
                  getCurrentStep(currentPage) >= index
                    ? blueColor04
                    : greyColor40
                }
                lineHeight="15px"
              >
                {item.subText}
              </Typography> */}
            </Box>
          </Box>

          {INVENTORY_BULK_UPLOAD_STEPPER.length !== index + 1 && (
            <Box
              sx={{
                width: "80px",
                height: "1.5px",
                backgroundColor: 'rgba(0,0,0,0.2)',
                mt: -3,
                position: "absolute",
                left: "140px",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default UploadStepper;

const styles = {
  countCircle: (isActive) => ({
    width: "25px",
    height: "25px",
    borderRadius: "40px",
    backgroundColor: isActive ? blueColor04 : whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 500,
    color: isActive ? whiteColor : greyColor40,
    border: isActive ? `1px solid ${blueColor04}` : `1px solid ${greyColor40}`,
  }),
};
